export const CART_PRODUCT_TEST_ID = {
  quantityDropdown: 'quantity-dropdown',
};
